/* import __COLOCATED_TEMPLATE__ from './client-section.hbs'; */
import { dateFormat } from 'client-portal/utils/date-time';
import { modifier } from 'ember-modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './client-section.module.scss';

export default class SiteBillingOutOfNetworkFormClientSection extends Component {
  @service store;

  styles = styles;
  dateFormat = dateFormat;

  onInsert = modifier(
    () => {
      this.args.onTrack('client_info');
      this.args.client.set('isDirty', false);
    },
    { eager: false }
  );
}
